import { ruPlural } from '@/lib/content/declension';

/**
 * Общие UI-тексты сервис-страниц (esim/vpn/insurance/transport/stay/tours):
 * надзаголовки секций, метки якорей, теги, общие подписи и кнопки.
 * Вертикаль-специфичные строки (заголовки/лиды/CTA конкретного сервиса) живут
 * в своих namespace в sections/services.js.
 */
export const servicePage = {
    en: {
        eyebrow: {
            benefits: 'Benefits',
            providers: 'Providers',
            guide: 'Guide',
            discounts: 'Discounts',
            qa: 'Questions & answers',
            resources: 'Helpful resources',
        },
        anchor: {
            providers: 'Providers',
            how: 'How to',
            discounts: 'Discounts',
            faq: 'FAQ',
            articles: 'Articles',
        },
        tag: { faq: 'FAQ', current: 'current', blog: 'blog' },
        popularQuestions: 'Popular questions',
        details: 'Details →',
        toSite: 'Go to site →',
        allArticles: 'All articles',
        stepsWord: (n) => (n === 1 ? 'step' : 'steps'),
    },
    ru: {
        eyebrow: {
            benefits: 'Преимущества',
            providers: 'Провайдеры',
            guide: 'Инструкция',
            discounts: 'Скидки',
            qa: 'Вопросы и ответы',
            resources: 'Полезные материалы',
        },
        anchor: {
            providers: 'Провайдеры',
            how: 'Как оформить',
            discounts: 'Скидки',
            faq: 'Вопросы',
            articles: 'Статьи',
        },
        tag: { faq: 'FAQ', current: 'актуально', blog: 'блог' },
        popularQuestions: 'Популярные вопросы',
        details: 'Подробнее →',
        toSite: 'На сайт →',
        allArticles: 'Все статьи',
        stepsWord: (n) => ruPlural(n, ['шаг', 'шага', 'шагов']),
    },
};
